import {
  Box,
  Button,
  MenuItem,
  Paper,
  Select,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
// import _debounce from 'lodash/debounce';

const initailData: any = {
  idx: -1,
  id: "",
  worker: "",
  work_date: "",
  work_yn: "",
  use_check: "",

  prc_worker:"",
  prc_date: "",
  prc_yn:"",

  isp_worker: "",
  isp_date: "",
  isp_yn: "",

  category: "",
  answer: "",

  translate_need:"",

  question_vi : "",
  best_answer_vi : "",
  correct_answer_vi_1 : "",
  correct_answer_vi_2 : "",
  correct_answer_vi_3 : "",
  correct_answer_vi_4 : "",
  correct_answer_vi_5 : "",
  correct_answer_vi_6 : "",
  incorrect_answer_vi_1 : "",
  incorrect_answer_vi_2 : "",
  incorrect_answer_vi_3 : "",
  incorrect_answer_vi_4 : "",
  incorrect_answer_vi_5 : "",
  incorrect_answer_vi_6 : "",
  
  question_ko : "",
  best_answer_ko : "",
  correct_answer_ko_1 : "",
  correct_answer_ko_2 : "",
  correct_answer_ko_3 : "",
  correct_answer_ko_4 : "",
  correct_answer_ko_5 : "",
  correct_answer_ko_6 : "",
  incorrect_answer_ko_1 : "",
  incorrect_answer_ko_2 : "",
  incorrect_answer_ko_3 : "",
  incorrect_answer_ko_4 : "",
  incorrect_answer_ko_5 : "",
  incorrect_answer_ko_6 : "",
  
  question_en : "",
  best_answer_en : "",
  correct_answer_en_1 : "",
  correct_answer_en_2 : "",
  correct_answer_en_3 : "",
  correct_answer_en_4 : "",
  correct_answer_en_5 : "",
  correct_answer_en_6 : "",
  incorrect_answer_en_1 : "",
  incorrect_answer_en_2 : "",
  incorrect_answer_en_3 : "",
  incorrect_answer_en_4 : "",
  incorrect_answer_en_5 : "",
  incorrect_answer_en_6 : "",
};


const Task04CreateDialog = (props: any) => {

  const [data, setData] = useState<any>(initailData);

  // const [auths, setAuths] = useState([]);
  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  // const getAuths = async () => {
  //   var result = await api.get("/getAuths");
  //   setAuths(result.data.data);
  // };


  const saveTfqaData = async () => {

    const formData = new FormData();

    if(email !== "vanvan511@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" && data.category === "None" && data.use_check !== "F"){
      alert('Category 를 선택하세요.')
      return;
    }

    if(email !== "vanvan511@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" &&
      (data.question_vi === null || data.question_en === null || data.question_ko === null || data.question_vi === "" || data.question_en === "" || data.question_ko === "")
    ){
      alert('Question 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan511@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" &&
      (data.best_answer_vi === null || data.best_answer_en === null || data.best_answer_ko === null || data.best_answer_vi === "" || data.best_answer_en === "" || data.best_answer_ko === "")
    ){
      alert('best_answer 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan511@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" &&
      (data.correct_answer_vi_1 === null || data.correct_answer_en_1 === null || data.correct_answer_ko_1 === null || data.correct_answer_vi_1 === "" || data.correct_answer_en_1 === "" || data.correct_answer_ko_1 === "")
    ){
      alert('correct_answer (1) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan522@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" &&
      (data.correct_answer_vi_2 === null || data.correct_answer_en_2 === null || data.correct_answer_ko_2 === null || data.correct_answer_vi_2 === "" || data.correct_answer_en_2 === "" || data.correct_answer_ko_2 === "")
    ){
      alert('correct_answer (2) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan533@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" &&
      (data.correct_answer_vi_3 === null || data.correct_answer_en_3 === null || data.correct_answer_ko_3 === null || data.correct_answer_vi_3 === "" || data.correct_answer_en_3 === "" || data.correct_answer_ko_3 === "")
    ){
      alert('correct_answer (3) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan544@naver.com" && email !== "buiminhthuy740@gmail.com" && email !== "go@gmail.com" &&
      (data.correct_answer_vi_4 === null || data.correct_answer_en_4 === null || data.correct_answer_ko_4 === null || data.correct_answer_vi_4 === "" || data.correct_answer_en_4 === "" || data.correct_answer_ko_4 === "")
    ){
      alert('correct_answer (4) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan555@naver.com" && email !== "buiminhthuy750@gmail.com" && email !== "go@gmail.com" &&
      (data.correct_answer_vi_5 === null || data.correct_answer_en_5 === null || data.correct_answer_ko_5 === null || data.correct_answer_vi_5 === "" || data.correct_answer_en_5 === "" || data.correct_answer_ko_5 === "")
    ){
      alert('correct_answer (5) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan666@naver.com" && email !== "buiminhthuy760@gmail.com" && email !== "go@gmail.com" &&
      (data.correct_answer_vi_6 === null || data.correct_answer_en_6 === null || data.correct_answer_ko_6 === null || data.correct_answer_vi_6 === "" || data.correct_answer_en_6 === "" || data.correct_answer_ko_6 === "")
    ){
      alert('correct_answer (6) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan511@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" &&
      (data.incorrect_answer_vi_1 === null || data.incorrect_answer_en_1 === null || data.incorrect_answer_ko_1 === null || data.incorrect_answer_vi_1 === "" || data.incorrect_answer_en_1 === "" || data.incorrect_answer_ko_1 === "")
    ){
      alert('incorrect_answer (1) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan522@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" &&
      (data.incorrect_answer_vi_2 === null || data.incorrect_answer_en_2 === null || data.incorrect_answer_ko_2 === null || data.incorrect_answer_vi_2 === "" || data.incorrect_answer_en_2 === "" || data.incorrect_answer_ko_2 === "")
    ){
      alert('incorrect_answer (2) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan533@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" &&
      (data.incorrect_answer_vi_3 === null || data.incorrect_answer_en_3 === null || data.incorrect_answer_ko_3 === null || data.incorrect_answer_vi_3 === "" || data.incorrect_answer_en_3 === "" || data.incorrect_answer_ko_3 === "")
    ){
      alert('incorrect_answer (3) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan544@naver.com" && email !== "buiminhthuy740@gmail.com" && email !== "go@gmail.com" &&
      (data.incorrect_answer_vi_4 === null || data.incorrect_answer_en_4 === null || data.incorrect_answer_ko_4 === null || data.incorrect_answer_vi_4 === "" || data.incorrect_answer_en_4 === "" || data.incorrect_answer_ko_4 === "")
    ){
      alert('incorrect_answer (4) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan555@naver.com" && email !== "buiminhthuy750@gmail.com" && email !== "go@gmail.com" &&
      (data.incorrect_answer_vi_5 === null || data.incorrect_answer_en_5 === null || data.incorrect_answer_ko_5 === null || data.incorrect_answer_vi_5 === "" || data.incorrect_answer_en_5 === "" || data.incorrect_answer_ko_5 === "")
    ){
      alert('incorrect_answer (5) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email !== "vanvan666@naver.com" && email !== "buiminhthuy760@gmail.com" && email !== "go@gmail.com" &&
      (data.incorrect_answer_vi_6 === null || data.incorrect_answer_en_6 === null || data.incorrect_answer_ko_6 === null || data.incorrect_answer_vi_6 === "" || data.incorrect_answer_en_6 === "" || data.incorrect_answer_ko_6 === "")
    ){
      alert('incorrect_answer (6) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    formData.append("email", email);

    formData.append("ins_worker", worker);

    formData.append("datas", JSON.stringify(data));

    // console.log('수정할 데이터', JSON.stringify(data))

    // formData.append("nvConScript", JSON.stringify(con_script));

    await api.post("/vie-04-tfqaInsert",formData)
    .then((res:any) => { alert("신규작성이 완료되었습니다."); props.updateAfter(); setData(initailData); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }

  const openGuideWindow = () => {
    const imageUrl = `${process.env.PUBLIC_URL}/img/vie-task/Vie-TruthfulQA.jpg`;

    window.open(imageUrl, '_blank');
  }

  useEffect(() => {
    // getAuths();
    setData(initailData);
    // setData(props.rowDetail);
  }, [props.rowDetail]);

  return (
    <Paper sx={{width:"100%", overflow: "auto", padding:"20px"}}>
      {data ? 
      <>
      <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>TFQA 신규작성</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box>
        <Box sx={{position: "sticky",top: "-16px", zIndex: 1, backgroundColor:"#fff"}} >

          {/* <Box display="flex" justifyContent="center"> */}
          <Box display="flex">

            <Box display="flex" sx={{marginLeft: "50px"}}>
              <Box sx={{width:"100%"}}>
                
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"96px"}}>Category</Box>
                  <Select id="category" value={data.category} onChange={(e) => {setData({ ...data, category: e.target.value });}} sx={{color:"green",width:"250px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                    <MenuItem dense value={"사회/정치/산업"}>사회/정치/산업</MenuItem>
                    <MenuItem dense value={"건강/의학"}>건강/의학</MenuItem>
                    <MenuItem dense value={"날씨/자연/동식물"}>날씨/자연/동식물</MenuItem>
                    <MenuItem dense value={"음식/일상생활"}>음식/일상생활</MenuItem>
                    <MenuItem dense value={"IT/과학"}>IT/과학</MenuItem>
                    <MenuItem dense value={"역사/문화/예술/공예/의상"}>역사/문화/예술/공예/의상</MenuItem>
                    <MenuItem dense value={"일반상식/기타"}>일반상식/기타</MenuItem>
                  </Select>
                  <Button variant="contained" size="small" color="secondary" sx={{fontWeight:700, margin:"8px 16px 8px 250px"}} onClick={() => openGuideWindow()}>
                    OPEN GUIDE
                  </Button>
                </Box>
              </Box>
            </Box>
        
          {/* </form> */}
          </Box>

          <Box display="flex" justifyContent="center" >

              <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
                  <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{fontSize:"22px", fontWeight:700, textAlign:"center", margin:"2px"}}>EN</Box>
                          <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                          <Box><textarea value={data.question_en || ""} onChange={(e) => {setData({ ...data, question_en: e.target.value });}} style={{width:"410px",minHeight:"55px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"4px"}}>
                          <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Best Answer</Box>
                          <Box><textarea value={data.best_answer_en || ""} onChange={(e) => {setData({ ...data, best_answer_en: e.target.value });}} style={{width:"410px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
              </Paper>
              <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
                <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{fontSize:"22px", fontWeight:700, textAlign:"center", margin:"2px"}}>VI</Box>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                        <Box><textarea spellCheck="false" value={data.question_vi || ""} onChange={(e) => {setData({ ...data, question_vi: e.target.value });}} style={{width:"410px",minHeight:"55px", fontSize:"18px",padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Best Answer</Box>
                        <Box><textarea spellCheck="false" value={data.best_answer_vi || ""} onChange={(e) => {setData({ ...data, best_answer_vi: e.target.value });}} style={{width:"410px",minHeight:"40px", fontSize:"18px",padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
              <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
                <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{fontSize:"22px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                        <Box><textarea value={data.question_ko || ""} onChange={(e) => {setData({ ...data, question_ko: e.target.value });}} style={{width:"410px",minHeight:"55px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Best Answer</Box>
                        <Box><textarea value={data.best_answer_ko || ""} onChange={(e) => {setData({ ...data, best_answer_ko: e.target.value });}} style={{width:"410px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>

              </Box>

              </Box>

              <Box display="flex" justifyContent="center" sx={{textAlign:"center", marginTop:"2px", background: "linear-gradient(to right, #e6e6e6 30%, #deebfa 70%)"}}>
                <Box sx={{fontSize:"36px", paddingTop:"8px", color:"#60ad50", fontWeight:700,width:"100%"}}></Box>
              </Box>
              
            </Box>


            <Box sx={{ background: "linear-gradient(to right, #e6e6e6 30%, #deebfa 70%)"}}>
              <Box display="flex" justifyContent="center" >
                  <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
                  <Box sx={{backgroundColor:"#c3f1c7"}}>
                      <Box sx={{width:"420px",margin:"4px"}}>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Correct Answer</Box>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>1</Box>
                            <Box><textarea value={data.correct_answer_en_1 || ""} onChange={(e) => {setData({ ...data, correct_answer_en_1: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>2</Box>
                          <Box><textarea value={data.correct_answer_en_2 || ""} onChange={(e) => {setData({ ...data, correct_answer_en_2: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>3</Box>
                          <Box><textarea value={data.correct_answer_en_3 || ""} onChange={(e) => {setData({ ...data, correct_answer_en_3: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>4</Box>
                          <Box><textarea value={data.correct_answer_en_4 || ""} onChange={(e) => {setData({ ...data, correct_answer_en_4: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>5</Box>
                          <Box><textarea value={data.correct_answer_en_5 || ""} onChange={(e) => {setData({ ...data, correct_answer_en_5: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>6</Box>
                          <Box><textarea value={data.correct_answer_en_6 || ""} onChange={(e) => {setData({ ...data, correct_answer_en_6: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                  </Box>
                  <Box sx={{backgroundColor:"#ffbebe"}}>
                      <Box sx={{width:"420px",margin:"4px"}}>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Incorrect Answer</Box>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>1</Box>
                            <Box><textarea value={data.incorrect_answer_en_1 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_en_1: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>2</Box>
                          <Box><textarea value={data.incorrect_answer_en_2 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_en_2: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>3</Box>
                          <Box><textarea value={data.incorrect_answer_en_3 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_en_3: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>4</Box>
                          <Box><textarea value={data.incorrect_answer_en_4 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_en_4: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>5</Box>
                          <Box><textarea value={data.incorrect_answer_en_5 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_en_5: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>6</Box>
                          <Box><textarea value={data.incorrect_answer_en_6 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_en_6: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                  </Box>
                  </Paper>

                  <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
                    <Box sx={{backgroundColor:"#c3f1c7"}}>
                          <Box sx={{width:"420px",margin:"4px"}}>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Correct Answer</Box>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>1</Box>
                            <Box><textarea spellCheck="false" value={data.correct_answer_vi_1 || ""} onChange={(e) => {setData({ ...data, correct_answer_vi_1: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>2</Box>
                            <Box><textarea spellCheck="false" value={data.correct_answer_vi_2 || ""} onChange={(e) => {setData({ ...data, correct_answer_vi_2: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>3</Box>
                          <Box><textarea spellCheck="false" value={data.correct_answer_vi_3 || ""} onChange={(e) => {setData({ ...data, correct_answer_vi_3: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>4</Box>
                          <Box><textarea spellCheck="false" value={data.correct_answer_vi_4 || ""} onChange={(e) => {setData({ ...data, correct_answer_vi_4: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>5</Box>
                          <Box><textarea spellCheck="false" value={data.correct_answer_vi_5 || ""} onChange={(e) => {setData({ ...data, correct_answer_vi_5: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>6</Box>
                          <Box><textarea spellCheck="false" value={data.correct_answer_vi_6 || ""} onChange={(e) => {setData({ ...data, correct_answer_vi_6: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{backgroundColor:"#ffbebe"}}>
                          <Box sx={{width:"420px",margin:"4px"}}>
                        <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Incorrect Answer</Box>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>1</Box>
                            <Box><textarea spellCheck="false" value={data.incorrect_answer_vi_1 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_vi_1: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>2</Box>
                            <Box><textarea spellCheck="false" value={data.incorrect_answer_vi_2 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_vi_2: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>3</Box>
                          <Box><textarea spellCheck="false" value={data.incorrect_answer_vi_3 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_vi_3: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>4</Box>
                          <Box><textarea spellCheck="false" value={data.incorrect_answer_vi_4 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_vi_4: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>5</Box>
                          <Box><textarea spellCheck="false" value={data.incorrect_answer_vi_5 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_vi_5: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{width:"350px",margin:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                          <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>6</Box>
                          <Box><textarea spellCheck="false" value={data.incorrect_answer_vi_6 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_vi_6: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                  <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
                  <Box sx={{backgroundColor:"#c3f1c7"}}>
                    <Box sx={{width:"420px",margin:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Correct Answer</Box>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>1</Box>
                          <Box><textarea value={data.correct_answer_ko_1 || ""} onChange={(e) => {setData({ ...data, correct_answer_ko_1: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>2</Box>
                          <Box><textarea value={data.correct_answer_ko_2 || ""} onChange={(e) => {setData({ ...data, correct_answer_ko_2: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>3</Box>
                          <Box><textarea value={data.correct_answer_ko_3 || ""} onChange={(e) => {setData({ ...data, correct_answer_ko_3: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>4</Box>
                          <Box><textarea value={data.correct_answer_ko_4 || ""} onChange={(e) => {setData({ ...data, correct_answer_ko_4: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>5</Box>
                          <Box><textarea value={data.correct_answer_ko_5 || ""} onChange={(e) => {setData({ ...data, correct_answer_ko_5: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>6</Box>
                          <Box><textarea value={data.correct_answer_ko_6 || ""} onChange={(e) => {setData({ ...data, correct_answer_ko_6: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{backgroundColor:"#ffbebe"}}>
                    <Box sx={{width:"420px",margin:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>InCorrect Answer</Box>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>1</Box>
                          <Box><textarea value={data.incorrect_answer_ko_1 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_ko_1: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>2</Box>
                          <Box><textarea value={data.incorrect_answer_ko_2 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_ko_2: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>3</Box>
                          <Box><textarea value={data.incorrect_answer_ko_3 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_ko_3: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>4</Box>
                          <Box><textarea value={data.incorrect_answer_ko_4 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_ko_4: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>5</Box>
                          <Box><textarea value={data.incorrect_answer_ko_5 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_ko_5: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{width:"350px",margin:"4px"}}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"16px", margin:"2px 0px 0px -2px", fontWeight:700}}>6</Box>
                          <Box><textarea value={data.incorrect_answer_ko_6 || ""} onChange={(e) => {setData({ ...data, incorrect_answer_ko_6: e.target.value });}} style={{width:"380px",minHeight:"45px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  </Paper>

              </Box>
            </Box>
        
      <Box display="flex" justifyContent="right" sx={{margin:"20px"}}>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            saveTfqaData();
          }}
        >
          SAVE
        </Button>
      </Box>
      </> : "데이터가 없습니다."}
      
    </Paper>
  );
};

export default Task04CreateDialog;
